import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Loader from './Components/Loader';
import ScrollTop from './Components/ScrollTop';
import ModularnySystemPage from './Components/Pages/ModularnySystemPage';
import FaqPage from './Components/Pages/FaqPage';
import HomePage from './Components/Pages/HomePage';

const ScrollTopWrapper = () => {
  const location = useLocation();
  
  // Define paths where ScrollTop should not be rendered
  const noScrollTopPaths = ['/login', '/register'];

  return (
    <>
      {/* Conditionally render ScrollTop based on the current path */}
      {!noScrollTopPaths.includes(location.pathname) && <ScrollTop />}
      <Routes>
        <Route path='/' element={<HomePage />} />       
        <Route path='/modularny-system' element={<ModularnySystemPage />} />
        <Route path='/otazky-a-odpovede' element={<FaqPage />} />
      </Routes>
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <Loader />
      <ScrollTopWrapper />
    </BrowserRouter>
  );
};

export default App;